const header = {
  applicationHeading: "{{applicationHeading}}",
  logout: "Logout",
};

export default header;
